var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"resumo-proposta"}},[_c('v-row',[_c('v-col',{staticClass:"py-0 grey--text text--darken-3 font-weight-medium",attrs:{"cols":"12"}},[_c('resumo-cliente-dados-gerais',{attrs:{"model":_vm.model}}),_c('br')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }